import { useMemo } from 'react';
import { useProducts } from '../products';
import { useEpicCounts } from './useEpicCounts';
import { useReviewData } from './useReviewData';
import { mergeQuarterData, buildQuartersDataForProduct } from '../../api/projects';
import type { AllQuartersData } from '../../api/shared/types';

export const quartersDataQueryKey = (
  projectName: string,
  fiscalYearQuarters: string[],
  fiscalYear?: string,
) => ['quartersData', projectName, fiscalYearQuarters, fiscalYear] as const;

export function useQuartersData(projectName: string, fiscalYearQuarters: string[], fiscalYear?: string) {
  const { data: products = [] } = useProducts({ limit: 1000, fiscalYear });
  const { data: epicCounts = [], isLoading: epicCountsLoading } = useEpicCounts(fiscalYearQuarters);
  const { data: reviewData = [], isLoading: reviewDataLoading } = useReviewData(fiscalYearQuarters);

  const data = useMemo((): AllQuartersData => {
    if (!products.length || !projectName) return {};
    const quarterDataItems = mergeQuarterData(epicCounts, reviewData);
    return buildQuartersDataForProduct(products, projectName, fiscalYearQuarters, quarterDataItems);
  }, [products, epicCounts, reviewData, projectName, fiscalYearQuarters]);

  return {
    data,
    isLoading: epicCountsLoading || reviewDataLoading,
  };
}
